import { X } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * The readout of what is currently narrowing a list.
 *
 * The old app rendered this row on every queue as static text badges. Here each
 * chip is also the control that removes the filter it names, so the row is a
 * way out of a filter as well as a record of it — otherwise a chip row and a
 * Filter button are two places showing the same state and only one acting on it.
 *
 * The clear button shows only on pages that pass `onClearAll`: as "Clear all"
 * once two chips are showing, or — with `clearMin={1}` and `clearLabel="Clear"` —
 * from the first chip, as the invoice queues do.
 *
 * Renders nothing when no filter is applied, so the toolbar keeps its height on
 * a resting page.
 */
export function ActiveFilterChips({
  chips,
  onRemove,
  onClearAll,
  clearLabel = "Clear all",
  clearMin = 2,
  className,
}) {
  if (!chips?.length) return null;

  return (
    <div
      className={["active-filter-bar", className].filter(Boolean).join(" ")}
      role="group"
      aria-label="Active filters"
    >
      {chips.map((chip) => (
        <button
          key={chip.key}
          type="button"
          className="active-filter-chip"
          onClick={() => onRemove(chip)}
          aria-label={`Remove filter ${chip.label} ${chip.value}`}
        >
          <span className="active-filter-chip-label">{chip.label}</span>
          <span className="active-filter-chip-value">{chip.value}</span>
          <X className="active-filter-chip-icon" aria-hidden="true" />
        </button>
      ))}

      {onClearAll && chips.length >= clearMin && (
        <Button
          type="button"
          variant="ghost"
          size="sm"
          className="queue-filter-clear"
          onClick={onClearAll}
        >
          <X data-icon="inline-start" />
          {clearLabel}
        </Button>
      )}
    </div>
  );
}
